import { QueryFeature } from '../../../../../config/queryClient';

enum QueryKey {
  Groups = 'Groups',
  Options = 'Options',
}

export const whatIfsQueryKeys = {
  groups: (clientId: number, fpId: string, whatIfAreaId: string, goalId?: string) => [
    QueryFeature.WhatIfs,
    QueryKey.Groups,
    clientId,
    fpId,
    whatIfAreaId,
    goalId,
  ],

  options: (clientId: number, fpId: string, whatIfTypeName: string, goalId?: string) => [
    QueryFeature.WhatIfs,
    QueryKey.Options,
    clientId,
    fpId,
    whatIfTypeName,
    goalId,
  ],

  optionsAll: (clientId: number) => [QueryFeature.WhatIfs, QueryKey.Options, clientId],
};
